export default __webpack_public_path__ + "static/media/icono-vidriera.549c95f8.png";